export const defaultFormVal = {
  "welcome_message": {
      "en": "<div></div>",
      "de": "<div></div>",
      "it": "<div></div>",
      "nl": "<div></div>"
  },
  "thank_you_message": {
      "en": "<div></div>",
      "de": "<div></div>",
      "it": "<div></div>",
      "nl": "<div></div>"
  },
  "closed_message": {
    "en": "<div></div>",
    "de": "<div></div>",
    "it": "<div></div>",
    "nl": "<div></div>"
  },
  "reminder_duration": 0,
  "dialogue_fields": [],
  
  "header_background_color": '',
  "customer_message_background_color": '',
  "support_message_background_color": '',
  "background_text_font_color": '',
  "message_text_font_color": '',
  "background_image": '',
  "chat_logo": ''
}